// eslint-disable-next-line @typescript-eslint/typedef
export const DebuggerEvents = {
  lifecycleEvent: 'debugger.lifecycleEvent',
  debuggerConnected: 'debugger.connected',
};
